import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Home as HomeIcon } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { themeStyle } from "../components/Components";
import { useSelector, useDispatch } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { logout } from "../actions/auth";

const NotFoundPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();

  const [isLoggingOut, setIsLoggingOut] = useState(false);

  function getout() {
    setIsLoggingOut(true);
    dispatch(logout());
    return null;
  }

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          p: 3,
        }}
      >
        <Typography
          variant={isMobile ? "h2" : "h1"}
          sx={{
            fontWeight: "bold",
            mb: 2,
            color: "black",
          }}
        >
          404
        </Typography>

        <Typography variant={isMobile ? "h5" : "h4"} sx={{ mb: 2 }}>
          Oops! Page not found
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, maxWidth: 600 }}>
          The page you are looking for might have been removed, had its name
          changed, does not exist, or is temporarily unavailable.
        </Typography>

        <Button
          variant="contained"
          size="large"
          startIcon={<HomeIcon />}
          onClick={() => getout()}
          sx={{
            backgroundColor: themeStyle.primaryColor,
            borderRadius: 2,
            px: 4,
            py: 1.5,
            textTransform: "none",
            fontSize: isMobile ? "1rem" : "1.1rem",
          }}
        >
          Go to Homepage
        </Button>

        {isLoggingOut ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <CircularProgress />{" "}
          </div>
        ) : (
          <span></span>
        )}

        <Box sx={{ height: "250px" }} />
      </Box>
    </Container>
  );
};

export default NotFoundPage;
